module.exports = __webpack_public_path__ + "img/logo.2a00d0d7.png";